import React, { Fragment, Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import { formatIdentifierForApi } from '../utils/incidentHelper';
import { history } from '../index';
import SpliceDialog from './splicing/SpliceDialog';
class UniquenessPopover extends Component {

  constructor(props) {
    super(props);

    this.state = {
      userMenuOpen: false,
      dataDictionaryOpen: false,
      showingNewIncidentDialog: false,
      showingReportingDialog: false,
      spliceMenuOpen: false,
      spliceModel: null,
      savedSpliceRecord: null
    };
  }

  viewIncident = (forId) =>
  {
    history.push(`/incidents/${forId}`);
  }

  spliceIncident = (itemIdToMerge) =>
  {
      window.api.getSpliceModel(this.props.incident.attributes.FORID, itemIdToMerge).then(resp => {
        this.setState({
          spliceMenuOpen: true,
          spliceModel: resp,
          savedSpliceRecord: resp.SavedSplicedRecord
        });
      });
  }
  closeSpliceDialog = () => {
    this.setState({
      spliceMenuOpen: false,
      spliceModel: null,
      savedSpliceRecord: null
    });
  }

  handleOnSpliceRecords = (savedSpliceRecord, attributesFromLosingFODR) =>
    {
      let spliceModel = this.state.spliceModel;

      let forIdsToSplice = [spliceModel.PrimaryFOR.FORID, spliceModel.SecondaryFOR.FORID];
      let selectedForID = savedSpliceRecord["FORID"];

      window.api.saveSpliceModel(forIdsToSplice, selectedForID, savedSpliceRecord, attributesFromLosingFODR).then(resp => {

        this.setState({
          spliceMenuOpen: false,
          spliceModel: null,
          savedSpliceRecord: null,
          userMenuOpen: false
        });

        this.props.spliceComplete(resp);


      });
    }

  userMenuClose = () => {
    this.setState({
      userMenuOpen: false,
    });
  };

  render() {

    var tableRows = [];
    const sortedRecords =  this.props.incident.attributes.UniquenessRecords.sort((a, b) => parseFloat(a.UniquenessScore) - parseFloat(b.UniquenessScore));

    for (var i = 0; i < sortedRecords.length; i++)
    {
      const showRow = formatIdentifierForApi(sortedRecords[i].ComparisonFORID) !== formatIdentifierForApi(sortedRecords[i].FORID);
      const labelToShow = (formatIdentifierForApi(this.props.incident.attributes.FORID) === formatIdentifierForApi(sortedRecords[i].FORID) ) ? sortedRecords[i].ComparisonIncidentName : sortedRecords[i].IncidentName;
      const itemIdToMerge = (formatIdentifierForApi(this.props.incident.attributes.FORID) === formatIdentifierForApi(sortedRecords[i].FORID) ) ? sortedRecords[i].ComparisonFORID : sortedRecords[i].FORID;

      if (showRow)
      {
          tableRows.push(
          <TableRow key={i}>
          <TableCell component="th" scope="row">
          <Button
            color="primary"
            variant="text"
            size="small"
            style={{justifyContent: "flex-start"}}
            onClick={e => { this.viewIncident(itemIdToMerge) } }>{labelToShow}</Button>

          </TableCell>

          <TableCell align="right">{sortedRecords[i].UniquenessScore.toFixed(2)}</TableCell>
          <TableCell component="th" scope="row">
          <Button
            color="primary"
            variant="outlined"
            size="small"
            disabled={this.props.userIsReadOnly}
            onClick={e => { this.spliceIncident(itemIdToMerge) } }>Splice</Button>

          </TableCell>
        </TableRow>
      )
    }
    }

      return (
            <Fragment>
            <Popover
              open={this.props.open}
              anchorEl={this.props.anchorEl}
              anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
              onClose={this.props.handleClose}>
              <Fragment>
              <Table size="small">
              <TableHead>
                <TableRow className="data-dictionary-header-tr">
                  <TableCell style={{color: "#fff", fontWeight:"bold"}}>Comparison</TableCell>
                  <TableCell align="right" style={{color: "#fff", fontWeight:"bold"}}>Score</TableCell>
                  <TableCell align="right" style={{color: "#fff", fontWeight:"bold"}}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
             {tableRows}
              </TableBody>
            </Table>
            </Fragment>
            </Popover>
            <SpliceDialog
              open={this.state.spliceMenuOpen}
              spliceModel={this.state.spliceModel}
              savedSpliceRecord={this.state.savedSpliceRecord}
              onSpliceRecords={this.handleOnSpliceRecords}
              onCloseSpliceDialog={this.closeSpliceDialog}
            />
          </Fragment>
      )
    }
  }



  export default UniquenessPopover
